import {BrowserRouter, Routes, Route, Navigate} from "react-router-dom";
import {useEffect, useState} from "react";
import {AuthContext} from "./AuthContext";
import {load_fetch, isUserInRole} from "./pr_utils";

import Layout from "./Layout";
import Home from "./Home";
import Directory from "./Directory";
import AboutUs from "./about_us";
import StatementOfFaith from "./statement_of_faith";
import History from "./history";
import ChurchLeaders from "./church_leaders";
import Heartland from "./heartland";
import WhatToExpect from "./what_to_expect";
import YouthNight from "./youth_night";
import NewHopeMissions from "./new_hope_missions";
import RanaesBaskets from "./ranaes_baskets";
import VisitUs from "./visit_us";
import ContactUs from "./contact_us";
import Sermons from "./sermons";
import BibleMemory from "./bible_memory";
import PrintDirectory from "./print_directory";
import Testimony from "./testimony";
import Calendar from "./Calendar";
import Dashboard from "./pages/Dashboard.jsx";
import ServicePlanner from "./pages/ServicePlanner";
import UserManagement from "./pages/UserManagement";
import AudioEditor from "./pages/AudioEditor";
import SongViewer from "./pages/SongViewer";
import ChordsEditor from "./pages/ChordsEditor";

function App() {
    const [authStatus, setAuthStatus] = useState(null);
    const [userInfo, setUserInfo] = useState(null);
    const authenticationStatus = { authStatus, setAuthStatus };

    useEffect(() => {
        check_authentication_status();

        const interval = setInterval(() => {
            check_authentication_status((data) => {
                const now = Math.floor(Date.now() / 1000);
                if (!data || data.ERROR || !data.person_id) {
                    setAuthStatus(false);
                    setUserInfo(null);
                    return;
                }
                const lastActivity = data.last_activity || 0;
                const age = now - lastActivity;

                // timeout after 20 minutes of inactivity
                if (age > 20 * 60) {
                    setAuthStatus(false);
                    setUserInfo(null);
                } else {
                    setAuthStatus(data);
                    setUserInfo(data);
                }
            });
        }, 60 * 1000);
        return () => clearInterval(interval);
    }, []);

    const check_authentication_status = (callback = null) => {
        load_fetch('Security_Handler.php', { operation: 'CHECK_AUTHENTICATION_STATUS' }, (data) => {
            if (callback) {
                callback(data);
            } else {
                if (!data.ERROR && !data.error) {
                    setUserInfo(data);
                    setAuthStatus(data);
                } else {
                    setUserInfo(null);
                    setAuthStatus(false);
                }
            }
        });
    };

    const clear_login_information = () => setAuthStatus(false);
    const update_user_info = (new_info) => setUserInfo(new_info);

    const canViewDirectory = () => {
        if (!authStatus) return false;
        return isUserInRole(authStatus, ['ADMIN', 'DIRECTORY_EDITOR', 'DIRECTORY_VIEWER']) === true;
    };

    if (authStatus === null) return <p>Loading (auth check)...</p>;

    return (
        <AuthContext.Provider value={authenticationStatus}>
            <BrowserRouter>
                <Routes>
                    {/* Routes WITHOUT the default layout */}
                    <Route path="/song_viewer" element={<SongViewer user_info={userInfo} />} />
                    <Route path="/print_directory" element={<PrintDirectory can_view_directory={canViewDirectory()} />} />

                    {/* Routes WITH the default layout */}
                    <Route
                        element={
                            <Layout
                                update_user_info={update_user_info}
                                app_logout_function={clear_login_information}
                                canViewDirectory={canViewDirectory}
                            />
                        }
                    >
                        <Route index element={<Home page_title="Home" />} />
                        <Route path="about_us" element={<AboutUs page_title="About Us" />} />
                        <Route
                            path="directory"
                            element={
                                canViewDirectory()
                                    ? <Directory user_info={userInfo} page_title="Church Directory" />
                                    : <Navigate to="/" replace />
                            }
                        />
                        <Route path="dashboard" element={<Dashboard user_info={userInfo} page_title="Dashboard" />} />
                        <Route path="service_planner" element={<ServicePlanner user_info={userInfo} page_title="Service Planner" />} />
                        <Route path="user_management" element={<UserManagement user_info={userInfo} page_title="User Management" />} />
                        <Route path="audio_edit" element={<AudioEditor user_info={userInfo} page_title="Audio Editor" />} />
                        <Route path="statement_of_faith" element={<StatementOfFaith page_title="Statement of Faith" />} />
                        <Route path="history" element={<History page_title="Church History" />} />
                        <Route path="church_leaders" element={<ChurchLeaders page_title="Church Leaders" />} />
                        <Route path="heartland" element={<Heartland page_title="Heartland Association of Churches" />} />
                        <Route path="what_to_expect" element={<WhatToExpect page_title="What to Expect" />} />
                        <Route path="youth_night" element={<YouthNight page_title="Youth Night" />} />
                        <Route path="new_hope_missions" element={<NewHopeMissions page_title="New Hope Missions" />} />
                        <Route path="ranaes_baskets" element={<RanaesBaskets page_title="Ranae's Baskets" />} />
                        <Route path="visit_us" element={<VisitUs page_title="Visit Us" />} />
                        <Route path="contact_us" element={<ContactUs page_title="Contact Us" />} />
                        <Route path="sermons" element={<Sermons page_title="Sermons" canEditSermons={canViewDirectory} />} />
                        <Route path="bible_memory" element={<BibleMemory page_title="Bible Memory" />} />
                        <Route path="testimony" element={<Testimony page_title="Testimony" />} />
                        <Route path="calendar" element={<Calendar page_title="Calendar" />} />
                        <Route
                            path="chords_editor"
                            element={
                                isUserInRole(authStatus, ['ADMIN', 'SERVICE_EDITOR'])
                                    ? <ChordsEditor page_title="Chords Editor" />
                                    : <Navigate to="/" replace />
                            }
                        />
                    </Route>
                </Routes>
            </BrowserRouter>
        </AuthContext.Provider>
    );
}

export default App;
























// import logo from './logo.svg';
// import {BrowserRouter, Routes, Route, Navigate} from "react-router-dom";
// import Layout from "./Layout";
// import Home from "./Home";
// import Directory from "./Directory";
// import AboutUs from "./about_us";
// import StatementOfFaith from "./statement_of_faith";
// import History from "./history";
// import ChurchLeaders from "./church_leaders";
// import Heartland from "./heartland";
// import WhatToExpect from "./what_to_expect";
// import YouthNight from "./youth_night";
// import NewHopeMissions from "./new_hope_missions";
// import RanaesBaskets from "./ranaes_baskets";
// import VisitUs from "./visit_us";
// import ContactUs from "./contact_us";
// import Sermons from "./sermons";
// import BibleMemory from "./bible_memory";
// import {load_fetch, isUserInRole} from "./pr_utils";
// import {useEffect, useRef, useState} from "react";
// import {AuthContext} from "./AuthContext";
// import PrintDirectory from "./print_directory";
// import Testimony from "./testimony";
// import Calendar from "./Calendar";
// import Dashboard from "./pages/Dashboard.jsx";
// import ServicePlanner from "./pages/ServicePlanner";
// import UserManagement from "./pages/UserManagement";
// import AudioEditor from "./pages/AudioEditor";
// import SongViewer from "./pages/SongViewer";
// import ChordsEditor from "./pages/ChordsEditor";
//
// function App() {
//   const [authStatus, setAuthStatus] = useState(null);
//   const authenticationStatus = {authStatus, setAuthStatus};
//   const [userInfo, setUserInfo] = useState(null);
//   //const [canViewDirectory, setCanViewDirectory] = useState(false);
//   //const canViewDirectory = useRef(false);
//
//   useEffect(() => {
//     check_authentication_status();
//
//       const interval = setInterval(() => {
//           // Ask the server for current session info
//           check_authentication_status((data) => {
//               const now = Math.floor(Date.now() / 1000); // current time in seconds
//
//               if (!data || data.ERROR || !data.person_id) {
//                   // Session is gone — log out
//                   setAuthStatus(false);
//                   setUserInfo(null);
//                   return;
//               }
//
//               const lastActivity = data.last_activity || 0;
//               const age = now - lastActivity;
//
//               if (age > 20 * 60) {
//                   // Inactive too long — logout
//                   console.log("Session timed out due to inactivity.");
//                   setAuthStatus(false);
//                   setUserInfo(null);
//               } else {
//                   // Session is still good
//                   console.log("Session still good.");
//                   //console.log(data.last_activity);
//                   const now = Math.floor(Date.now() / 1000); // current time in seconds
//                   const lastActivity = data.last_activity;   // e.g. 1718658000
//                   const secondsElapsed = now - lastActivity;
//                   //console.log("Seconds elapsed: " + secondsElapsed);
//                   setAuthStatus(data);
//                   setUserInfo(data);
//               }
//           });
//       }, 60 * 1000); // every minute
//
//       return () => clearInterval(interval);
//
//   }, []);
//
//   useEffect(() => {
//     //console.log(authStatus);
//   }, [authStatus])
//
//   const canViewDirectory = () => {
//       if(!authStatus) {
//           return false;
//       }
//
//
//       if (isUserInRole(authStatus, ['ADMIN', 'DIRECTORY_EDITOR', 'DIRECTORY_VIEWER'])) {
//           return true;
//       }
//
//   }
//
//   const check_authentication_status = (callback = null) => {
//
//     let url = 'Security_Handler.php';
//
//     let postData = {
//       operation: 'CHECK_AUTHENTICATION_STATUS'
//     }
//
//     load_fetch(url, postData, (data) => {
//         if(callback) {
//             callback(data);
//         } else {
//             if (!data['ERROR'] && !data['error']) {
//                 setUserInfo(data);
//                 setAuthStatus(data);
//             } else {
//                 //console.log("Not logged in.");
//                 setUserInfo(null);
//                 setAuthStatus(false);
//             }
//         }
//     });
//   }
//
//
//   const clear_login_information = () => {
//       setAuthStatus(false);
//   }
//   const update_user_info = (new_info) => {
//       setUserInfo(new_info);
//   }
//
//     // Wait for auth check to complete before rendering
//     if (authStatus === null) {
//         return <p>Loading (auth check)...</p>;
//     }
//
//   if(window.location.pathname.indexOf("print_directory") !== -1) {
//       return (
//           <AuthContext.Provider value={authenticationStatus}>
//           <BrowserRouter>
//               <Routes>
//                   <Route
//                       path="/print_directory"
//                       element={<PrintDirectory can_view_directory={canViewDirectory.current} />} />
//               </Routes>
//           </BrowserRouter>
//           </AuthContext.Provider>
//       )
//         //return <Navigate to='./pr_api/Print_Directory.php' replace={true} />
//
//   } else if(window.location.pathname.indexOf("song_viewer") !== -1) {
//       return (
//           <AuthContext.Provider value={authenticationStatus}>
//               <BrowserRouter>
//                   <Routes>
//                       <Route
//                           path="/song_viewer"
//                           element={<SongViewer />} />
//                   </Routes>
//               </BrowserRouter>
//           </AuthContext.Provider>
//       )
//   } else {
//       return (
//           <AuthContext.Provider value={authenticationStatus}>
//               <BrowserRouter>
//                   <Routes>
//                       <Route path="/" element={<Layout update_user_info={update_user_info}
//                                                        app_logout_function={clear_login_information}
//                                                        canViewDirectory={canViewDirectory}
//                       />}>
//                           <Route index element={<Home page_title="Home"/>}/>
//                           <Route path="about_us" element={<AboutUs page_title="About Us"/>}/>
//                           <Route
//                               path="directory"
//                               element={
//                                   canViewDirectory()
//                                       ? <Directory user_info={userInfo} page_title="Church Directory" />
//                                       : <Navigate to="/" replace />
//                               }
//                           />
//
//                           <Route path="dashboard"
//                                  element={<Dashboard user_info={userInfo} page_title="Dashboard"/>}/>
//                           <Route path="service_planner"
//                                  element={<ServicePlanner user_info={userInfo} page_title="Service Planner"/>}/>
//                           <Route path="user_management"
//                                  element={<UserManagement user_info={userInfo} page_title="User Management"/>}/>
//                           <Route path="song_viewer"
//                                  element={<SongViewer user_info={userInfo} page_title="User Management"/>}/>
//                           <Route path="audio_edit"
//                                  element={<AudioEditor user_info={userInfo} page_title="User Management"/>}/>
//                           <Route path="statement_of_faith"
//                                  element={<StatementOfFaith page_title="Statement of Faith"/>}/>
//                           <Route path="history" element={<History page_title="Church History"/>}/>
//                           <Route path="church_leaders" element={<ChurchLeaders page_title="Church Leaders"/>}/>
//                           <Route path="heartland"
//                                  element={<Heartland page_title="Heartland Association of Churches"/>}/>
//                           <Route path="what_to_expect" element={<WhatToExpect page_title="What to Expect"/>}/>
//                           <Route path="youth_night" element={<YouthNight page_title="Youth Night"/>}/>
//                           <Route path="new_hope_missions" element={<NewHopeMissions page_title="New Hope Missions"/>}/>
//                           <Route path="ranaes_baskets" element={<RanaesBaskets page_title="Ranae's Baskets"/>}/>
//                           <Route path="visit_us" element={<VisitUs page_title="Visit Us"/>}/>
//                           <Route path="contact_us" element={<ContactUs page_title="Contact Us"/>}/>
//                           <Route path="sermons" element={<Sermons page_title="Sermons" canEditSermons={canViewDirectory} />}/>
//                           <Route path="bible_memory" element={<BibleMemory page_title="Bible Memory"/>}/>
//                           <Route path="testimony" element={<Testimony page_title="Testimony"/>}/>
//                           <Route path="calendar" element={<Calendar page_title="Calendar"/>}/>
//                           <Route path="chords_editor" element={<ChordsEditor page_title="Chords Editor"/>} />
//                       </Route>
//                   </Routes>
//               </BrowserRouter>
//           </AuthContext.Provider>
//       );
//   }
// }
//
// export default App;
